// TopBar component
import { Breadcrumbs } from './ui/Breadcrumbs';
import { ThemeToggle } from './ui/theme-toggle';
import { Notifications } from './ui/Notifications';
import { SupportDialog } from './ui/SupportDialog';
import { OnlineUsersAvatars } from './ui/OnlineUsersAvatars';

interface TopBarProps {
  breadcrumbLastLabel?: string;
}

const TopBar = ({ breadcrumbLastLabel }: TopBarProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-3 sm:gap-4 md:gap-6">
      <div className="flex items-center min-w-0 flex-shrink-0">
        <Breadcrumbs lastLabelOverride={breadcrumbLastLabel} />
      </div>

      <div className="flex items-center gap-2 sm:gap-3 md:gap-4 flex-shrink-0">
        <div className="flex-shrink-0 hidden md:block">
          <OnlineUsersAvatars />
        </div>

        <div className="flex-shrink-0">
          <SupportDialog />
        </div>

        <div className="flex-shrink-0">
          <ThemeToggle />
        </div>

        <div className="flex-shrink-0">
          <Notifications />
        </div>
      </div>
    </div>
  );
};

export default TopBar;
